import React, { FC } from 'react';
import { Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { findAll } from 'images/us-energy-solutions';
import { LinkButton } from 'components/atoms';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(5, 0, 10),
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing(15, 0),
    },
  },
  image: {
    width: '100%',
    paddingTop: theme.spacing(10),
    [theme.breakpoints.up('md')]: {
      paddingTop: 0,
      maxWidth: 611,
    },
  },
  content: {
    flexDirection: 'column',
    justifyContent: 'center',
    display: 'flex',
  },
  text: {
    color: theme.palette.switchedColors.textGray,
    paddingTop: theme.spacing(4),
  },
  button: {
    backgroundColor: theme.palette.primary.light,
    marginTop: theme.spacing(6),
    maxWidth: 208,
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(9),
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
}));

const FindAll: FC = () => {
  const classes = useStyles();

  return (
    <Container fixed>
      <Grid container justifyContent="space-between" className={classes.root} spacing={4}>
        <Grid item sm={12} md={6}>
          <img src={findAll} alt={'find all the right answers'} className={classes.image} />
        </Grid>
        <Grid item sm={12} md={6} className={classes.content}>
          <Typography variant="h1">Find all the right answers</Typography>
          <Typography variant="body2" className={classes.text}>
            We've compiled an entire Insights section that gives our readers a better understanding of the services we offer. A
            sort of an FAQ section with answers to all the questions one might have regarding our solutions. Whether you're
            interested in Solar Energy, LED Services, or EV Charging, our Academies are bound to help you make the right call.
          </Typography>
          <LinkButton
            href="https://usenergysolutions.us/led-academy"
            color="primary"
            variant="contained"
            className={classes.button}
          >
            Check it out
          </LinkButton>
        </Grid>
      </Grid>
    </Container>
  );
};

export default FindAll;
